<template>
  <v-row>
    <v-col cols="12">
      <sub-radio-button
        :old-value="oldFrequency"
        :data="frequencyList"
        :editable="editable"
        class="mt-n8"
        @input="bindValue" />
    </v-col>
    <v-col
      cols="12"
      class="d-flex">
      <v-spacer />
      <v-btn
        v-if="editable"
        color="primary"
        @click="stepSubmit">
        ต่อไป
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions } from 'vuex'
import SubRadioButton from '@/components/form/SubRadioButton.vue'

export default {
  components: {
    SubRadioButton
  },
  props: {
    templateIndex: {
      type: Number,
      required: true
    },
    oldFrequency: {
      type: Object,
      default: () => {}
    },
    editable: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      field: '',
      more: '',
      firstTemplateList: [
        {
          title: 'ส่งครั้งเดียว',
          list: [
            { text: 'ส่งทันที', value: 'immediatly' },
            {
              text: 'ระบุเวลา',
              value: 'specify',
              append: [
                { fieldType: 'input', type: 'date' },
                { fieldType: 'input', type: 'time' }
              ]
            }
          ]
        },
        {
          title: 'ส่งหลายครั้ง',
          list: [
            {
              text: 'ทุกวันที่',
              value: 'scheduleOnDate',
              append: [
                { fieldType: 'input', type: 'number' },
                { fieldType: 'input', type: 'time' }
              ]
            },
            {
              text: 'ทุกวัน',
              value: 'scheduleOnDay',
              append: [
                { fieldType: 'input', type: 'day' },
                { fieldType: 'input', type: 'time' }
              ]
            },
            {
              text: 'ทุก',
              value: 'onPeriod',
              append: [
                { fieldType: 'input', type: 'number', appendText: 'วัน' },
                { fieldType: 'input', type: 'time' }
              ]
            },
            {
              text: 'หลังจากการซื้อสินค้าที่มียอดเกิน',
              value: 'onSpentTrigger',
              append: [
                { fieldType: 'input', type: 'number', appendText: 'บาท' },
                { fieldType: 'input', type: 'number', appendText: 'วัน' }
              ]
            },
            {
              text: 'กรณีพิเศษ',
              value: 'special',
              append: [
                { fieldType: 'input', type: 'special' },
                { fieldType: 'input', type: 'time' }
              ]
            }
          ]
        }
      ],
      secondTemplateList: [
        {
          title: 'เหตุการณ์',
          list: [
            {
              text: 'หลังจาก Template ก่อนหน้า',
              value: 'afterLatestTemplate',
              append: [
                { fieldType: 'input', type: 'number', appendText: 'วัน' },
                { fieldType: 'input', type: 'time' }
              ]
            },
            {
              text: 'หลังจากการซื้อสินค้าที่มียอดเกิน',
              value: 'onSpentTrigger',
              append: [
                { fieldType: 'input', type: 'number', appendText: 'บาท' },
                { fieldType: 'input', type: 'number', appendText: 'วัน' }
              ]
            }
          ]
        }
      ]
    }
  },
  computed: {
    frequencyList () {
      return this.templateIndex === 0 ? this.firstTemplateList : this.secondTemplateList
    }
  },
  methods: {
    ...mapActions({
      setSnackBar: 'Style/setSnackbar'
    }),
    bindValue (field, more) {
      this.field = field
      this.more = more
    },
    async stepSubmit () {
      try {
        if (this.field === 'scheduleOnDate' && this.more[0] < 10) {
          this.more[0] = `0${this.more[0]}`
        }

        if (this.field !== '') {
          this.$emit('input', {
            frequency: {
              field: this.field,
              more: this.more
            }
          }, 2)
        } else {
          this.$emit('validated-failure')
          this.setSnackBar({
            value: true,
            message: 'กรุณากรอกฟอร์มให้ถูกต้องและครบถ้วน',
            type: 'warning'
          })
        }
      } catch (e) {
        this.setSnackBar({
          value: true,
          message: `มีบางอย่างไม่ถูกต้อง (${e.message})`,
          type: 'error'
        })
      }
    },
    stepBack () {
      this.$emit('step-back')
    }
  }
}
</script>
